export default __webpack_public_path__ + "static/signage1-78a573768381a133d6ed6462df558ed8.webp";